import './KpiTile.css';

export interface KpiTileProps {
  label: string;
  value: string;
  /** Optional one-line clarification under the value. */
  hint?: string;
  className?: string;
}

export function KpiTile({ label, value, hint, className }: KpiTileProps) {
  return (
    <div className={className ? `${className} kpi-tile` : 'kpi-tile'}>
      <div className="kpi-tile__label">{label}</div>
      <div className="kpi-tile__value">{value}</div>
      {hint ? <div className="kpi-tile__hint">{hint}</div> : null}
    </div>
  );
}
